module.exports = __webpack_public_path__ + "static/media/relationship.55c2ebcc.svg";